import React from 'react';
import { ContentBoxElement as ContentBoxType } from '../../types/element.types';

interface ContentBoxElementProps {
  element: ContentBoxType;
}

/**
 * Content Box Element Renderer
 * Container for grouping elements
 */
const ContentBoxElement: React.FC<ContentBoxElementProps> = ({ element }) => {
  return (
    <div
      className="content-box-element"
      style={element.styles as React.CSSProperties}
    >
      {Array.isArray(element.content) && element.content.length > 0 ? (
        <div className="space-y-2">
          {/* Note: Nested elements would need recursive rendering */}
          <p className="text-gray-500 text-sm">Content box with {element.content.length} element(s)</p>
        </div>
      ) : (
        <p className="text-gray-400 text-sm text-center">Empty content box</p>
      )}
    </div>
  );
};

export default ContentBoxElement;

